import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';

const OrganizerLoginPage = lazy(() => import('../organizer/pages/OrganizerLoginPage'));
const OrganizerDashboardPage = lazy(() => import('../organizer/pages/OrganizerDashboardPage'));

export function OrganizerRoutes() {
  return (
    <Routes>
      <Route path=":eventId" element={<OrganizerLoginPage />} />
      <Route path=":eventId/dashboard" element={<OrganizerDashboardPage />} />
    </Routes>
  );
}

